import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  AdminAssociation,
  AdminAssociationValidation,
  AssociateAdminSchema,
} from './AssociateAdmin';

export const AssociateAdminFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'Assocaite_AdminSelect',
    component: AdminAssociation,
    schema: AssociateAdminSchema,
    validation: AdminAssociationValidation,
  }),
);
